import React, { useEffect, useState, useMemo, useContext } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Axios from '../../axios-proas';
import { useTranslation } from 'react-i18next';
import { SpinnerContainer } from '../../styles/Table.styled';
import { Spinner } from 'react-bootstrap';
import PdfViewer from '../../components/PdfViewer/PdfViewer'
import AddIcon from '@mui/icons-material/Add';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { AbilityContext } from '../../ability/AbilityContext';

function PdfViewerPage({ }) {
    let location = useLocation();
    let { uid } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();  
    const [confirmationGuideModalShow, setConfirmationGuideModalShow] = useState(true)

    const closePdfGuide = () => {
        setConfirmationGuideModalShow(false)
        window.close();
    }
 
    useEffect(() => {
       
      
    }, [])

    return (
        <>   
            {location.pathname?.split('/')?.pop() != "" &&
                <PdfViewer
                show={confirmationGuideModalShow}
                closeModal={closePdfGuide}
                typeGuide={location.pathname?.split('/')?.pop()}
                />
            }
        </>
    )
}

const mapStateToProps = (state) => ({

})
const mapDispatchToProps = dispatch => ({
 
})
export default connect(mapStateToProps, mapDispatchToProps)(PdfViewerPage)
